import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import PaymentService from './PaymentService';

import schema from './productJsonSchema';
import SettingsService from 'components/app/directory/SettingsService';
const mergeJsonSchema = (jsonSchema, currency) => {
  return jsonSchema.map(field => {
    if (field.type === 'group') {
      return {
        ...field,
        fields: field.fields.map(f => assignValueToJsonSchema(f, currency))
      };
    } else {
      return assignValueToJsonSchema(field, currency);
    }
  });
};
const assignValueToJsonSchema = (field, currency) => {
  if (field.type === 'currency') {
    return {
      ...field,
      currency: currency
    };
  }
  return field;
};
const WODProductForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [jsonSchema, setJSONSchema] = useState(schema);
  useEffect(() => {
    if (undefined !== identifier) {
      PaymentService.retrieveWODProduct(identifier)
        .then(data => {
          setData(data);
        })
        .catch(error => console.log(error));
    }
    SettingsService.retrieveDefaultCurrency()
      .then(currency => {
        console.log('Default currency:', currency);
        // Update the jsonSchema with the default currency
        const updatedJsonSchema = mergeJsonSchema(schema, currency);
        setJSONSchema(updatedJsonSchema);
        console.log('Updated data:', jsonSchema);
        setShowForm(true);
      })
      .catch(error => console.log('Error fetching default currency:', error));
  }, [identifier]);
  const handleWODProductFormSubmit = formData => {
    PaymentService.saveWODProduct(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save WODProduct',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save WODProduct');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator('Create WODProduct', ' ', []);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'WODProduct  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/wod/settings/payments"
        />
      )}
      <Card>
        <Card.Body>
          {showForm ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleWODProductFormSubmit}
              jsonSchema={jsonSchema}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, jsonSchema }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default WODProductForm;
